import { useQuery } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { isPrivateRoute } from "@/lib/consent/private-routes";
import { getWhatsAppContact } from "@/lib/whatsapp.functions";
import { isWhatsAppHiddenPath, whatsAppChatUrl } from "@/lib/whatsapp";

/** Gemeinsam mit dem Hoch-Button: Ist der WhatsApp-Button auf dieser Seite sichtbar? */
export function useWhatsAppContact(): { visible: boolean; chatUrl: string | null } {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const load = useServerFn(getWhatsAppContact);
  const { data } = useQuery({
    queryKey: ["whatsapp-contact"],
    queryFn: () => load(),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  const allowed = !isPrivateRoute(pathname) && !isWhatsAppHiddenPath(pathname);
  const chatUrl = data?.number ? whatsAppChatUrl(data.number) : null;
  return { visible: allowed && Boolean(chatUrl), chatUrl };
}
